import { render, staticRenderFns } from "./CustomComponentSelector.vue?vue&type=template&id=0bd5b45f&"
import script from "./CustomComponentSelector.vue?vue&type=script&lang=js&"
export * from "./CustomComponentSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports